/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import axios from 'axios/dist/axios.min.js'
import utils from '../../utils/utils';
import "./style.less";
import TrunTableGame from "./turntableGame";
import mock from "./mock";
class PipelineLottery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page_show: false,
      prize_list: [],
      draw: {},
      lucky_count: 1,
      showPrize: this.props.config.isPrizePopupShow === '是',
      lucky_image: '',
      click_limit: false,
      mask_show: false,
      prize_show: false,
      success_show: false,
      rule_show: false,
      mask_show_prop: false
    };
    this.unique_id = this.props.config.uniqueId;
    // this.unique_id = '2a0e6f9a-680b-4235-8f83-56145cb2'
    this.count = 3;
    this.delay = 4000;
    this.countDownInterVal = null;
  }

  componentDidMount() {
    this.createScript();
    this.getActivityDetail();
  }

  // 活动详情
  getActivityDetail = () => {
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/outside_info?from=not_shihuo&unique_id=' + this.unique_id,
      method: 'get',
      withCredentials: true,
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        const { prize_list, draw } = data;
        // const { prize_list, draw } = mock
        this.setState({
          prize_list,
          draw,
          lucky_image: draw.button_dynamic || "https://static.shihuocdn.cn/admin/files/20220626/3d7fdc585c7541ecc6bf441921910832.png",
        }, () => {
          setTimeout(() => {
            this.showPrizeList()
          }, 500);
          if (draw.model_id != 4) {
            const initSlotMachine = setInterval(() => {
              if (window.SlotMachine) {
                clearInterval(initSlotMachine);
                setTimeout(() => {
                  this.initGames();
                }, 600);
              }
            }, 50);
          }
        })
      }
    })
  }

  // 初始化动画
  initGames = () => {
    const casino1 = document.querySelector('#casino1');
    const casino2 = document.querySelector('#casino2');
    const casino3 = document.querySelector('#casino3');

    this.mCasino1 = window.SlotMachine && new window.SlotMachine(casino1, {
      active: 1,
      delay: 500,
      transition: "ease-in-out",
      direction: "down",
      distance: 20.5,
      onComplete: () => {
        this.mCasino2.stop();
      }
    });
    this.mCasino2 = window.SlotMachine && new window.SlotMachine(casino2, {
      active: 2,
      delay: 500,
      transition: "ease-in-out",
      direction: "down",
      distance: 20.5,
      onComplete: () => {
        this.mCasino3.stop();
      }
    });
    this.mCasino3 = window.SlotMachine && new window.SlotMachine(casino3, {
      active: 3,
      delay: 500,
      transition: "ease-in-out",
      direction: "down",
      distance: 20.5,
      onComplete: () => {
        utils.uploadTrack(this.props, {}, {
          blockName: 'winning-show'
        });
        this.setState({
          mask_show: true,
          success_show: true,
          click_limit: false
        });
      }
    });

    this.setState({
      page_show: true
    });
  }

  // 播放动画
  playGames = () => {
    utils.uploadTrack(this.props, {}, {
      blockName: 'start'
    });
    if (this.state.click_limit) {
      return;
    }
    if (this.state.lucky_count > 0) {
      this.setState({
        lucky_image: this.state.draw.button_static || "https://static.shihuocdn.cn/admin/files/20220626/3d7fdc585c7541ecc6bf441921910832.png",
        click_limit: true,
        lucky_count: this.state.lucky_count - 1
      });
    } else {
      // Toast.info("今日次数已用完", 2000);
      return;
    }
    this.mCasino1.shuffle(9999, 2);
    this.mCasino2.shuffle(9999, 2);
    this.mCasino3.shuffle(9999, 2);


    setTimeout(() => {
      this.mCasino1.stop();
    }, 2000);
  }

  // 展示奖品列表
  showPrizeList = () => {
    if (this.state.showPrize) {
      utils.uploadTrack(this.props, {}, {
        blockName: 'prize-show'
      });
      this.setState({
        mask_show: true,
        prize_show: true,
        count_down: 2,
        mask_show_prop: true
      });
      this.countDownInterVal = setInterval(() => {
        if (this.state.count_down <= 0) {
          clearInterval(this.countDownInterVal);
          this.countDownInterVal = null;
          this.setState({
            mask_show: false,
            prize_show: false,
            mask_show_prop: false
          })
        }
        this.setState({
          count_down: this.state.count_down - 1
        });
      }, 1000);
    }
  }

  // 跳过
  handleJump = () => {
    utils.uploadTrack(this.props, {}, {
      blockName: 'prize-skip'
    });
    if (this.countDownInterVal) {
      clearInterval(this.countDownInterVal);
      this.countDownInterVal = null;
    }
    this.setState({
      mask_show: false,
      prize_show: false,
      mask_show_prop: false
    })
  }

  handleRule = () => {
    this.setState({
      mask_show: true,
      rule_show: true
    });
  }

  render() {
    const { page_show, draw, prize_list, count_down, mask_show, prize_show, success_show, lucky_count, lucky_image, rule_show, mask_show_prop} = this.state;
    if(!draw.model_id) {
      return null
    }
    if (draw.model_id == 4) {
      return <TrunTableGame props={this.props} {...this.state} handleJump={this.handleJump} closePopup={this.closePopup} handleDownLoad={this.handleDownLoad} unique_id={this.unique_id}/> 
    } else {
      return (
        <div
          className="pipeline-lottery"
          {...this.props['customAttributes']}
        >
          <div
            className="games-area"
            style={{
              backgroundImage: `url(${draw.outside_bgimg || 'https://static.shihuocdn.cn/admin/files/20220626/b258b8227f4d251bc496c7963ddfd395.png'})`
            }}
          >
            <ul className="games-content fadeIn">
              <li id="casino1" className={page_show ? 'show' : 'hide'}>
                {
                  prize_list && prize_list.length > 0 && prize_list.map((item, index) => {
                    if (item.prize_pic && item.prize_pic[0]) {
                      return (
                        <div className="prize-item-wrap" key={index}>
                          <img src={item.prize_pic[0]} alt="" className={`slot slot${index}`} key={index} />
                        </div>
                      )
                    } else {
                      return null
                    }
                  })
                }
              </li>
              <li id="casino2" className={page_show ? 'show' : 'hide'}>
                {
                  prize_list && prize_list.length > 0 && prize_list.map((item, index) => {
                    if (item.prize_pic && item.prize_pic[0]) {
                      return (
                        <div className="prize-item-wrap" key={index}>
                          <img src={item.prize_pic[0]} alt="" className={`slot slot${index}`} key={index} />
                        </div>
                      )
                    } else {
                      return null
                    }
                  })
                }
              </li>
              <li id="casino3" className={page_show ? 'show' : 'hide'}>
                {
                  prize_list && prize_list.length > 0 && prize_list.map((item, index) => {
                    if (item.prize_pic && item.prize_pic[0]) {
                      return (
                        <div className="prize-item-wrap" key={index}>
                          <img src={item.prize_pic[0]} alt="" className={`slot slot${index}`} key={index} />
                        </div>
                      )
                    } else {
                      return null
                    }
                  })
                }
              </li>
            </ul>
            <p className="count-times">
              — 今日有{lucky_count}次转动机会 —
            </p>
            {
              lucky_image && 
                <img
                  src={lucky_image}
                  alt=""
                  className="lucky-btn"
                  onClick={() => this.playGames()}
                />
            }
            <div className="operation">
              <p className="btn left" onClick={() => this.handleDownLoad()}>下载安装</p>
              <p className="line"></p>
              <p className="btn right" onClick={() => this.handleRule()}>活动规则</p>
            </div>
            <img src={draw.back_pic || "https://static.shihuocdn.cn/admin/files/20220626/2865ff110ac593ceb000c0478a3e2a4a.png"} alt="" className="games-cover" />
          </div>
          <div className="persuade">
            <img src={draw.outside_bgimg_2 ? draw.outside_bgimg_2 : 'https://static.shihuocdn.cn/admin/files/20220113/56df51be172702ebb2a0e02710c0c97b.jpg'} className="bg-image" />
            <div className="shihuo-logo">
              <img src="https://static.shihuocdn.cn/admin/files/20211123/0b9ae6e1f574c47b057e44faa5c38123.png" alt="" className="logo" />
              <div className="desc">
                <p>运动潮流好物</p>
                <p>精选正品好价</p>
              </div>
            </div>
          </div>
          {/* 蒙层 */}
          { mask_show && <div className="mask"></div> }
  
          {/* 奖品列表 */}
          {
            prize_show && (
              <div
                style={{
                  backgroundImage:`url(${draw.prize_popup ? draw.prize_popup : "https://static.shihuocdn.cn/admin/files/20211119/cfd14a042a08f75681cccb78137305a4.png"})`
                }}
                className="prize-list"
              >
                {
                  prize_list && prize_list.length > 0 && (
                    <Fragment>
                      <img src={prize_list[1] && prize_list[1].prize_pic[0]} alt="" className="img-left" />
                      <img src={prize_list[2] && prize_list[2].prize_pic[0]} alt="" className="img-middle" />
                      <img src={prize_list[3] && prize_list[3].prize_pic[0]} alt="" className="img-right" />
                      <div className="count-down" onClick={() => {
                        this.handleJump();
                      }}>
                        跳过{count_down}
                      </div>
                    </Fragment>
                  )
                }
              </div>
            )
          }
  
          
          {/* 中奖弹窗 */}
          {
            success_show && (
              <div className="success-info" style={{backgroundImage: `url(${draw.winprize_popup ? draw.winprize_popup : 'https://static.shihuocdn.cn/admin/files/20220118/40c40dc29cfbae09a1e64f8909a97611.png'})`}}>
                {
                  prize_list && prize_list.length > 0 && (
                    <Fragment>
                      <div className="prize-info">
                        <img src={prize_list[2] && prize_list[2].prize_pic[0]} className="prize-image" />
                        <p className="prize-name">{prize_list[2] && prize_list[2].prize_name}</p>
                        <p className="prize-desc">{draw.outside_desc}</p>
                      </div>
                      {draw.outside_download_img && <img src={draw.outside_download_img} alt=""  className="download-btn" />}
                      <div className="download-area" onClick={() => this.handleDownLoad()}></div>
                      <img src="https://sh1.shihuocdn.cn/images/bargain/close.png" alt="" className="close" onClick={() => this.closePopup()} />
                    </Fragment>
                  )
                }
              </div>
            )
          }
  
          {/* 规则弹窗 */}
          {
            rule_show && (
              <div className="rule-popup">
              <div className="content">
                <p>参与游戏赢得活动机会，用户可下载安装识货APP，参加以下活动</p>
                <p>1.获得秒杀机会的用户，在活动页面点击下载识货APP打开后，会自动跳转进入秒杀页面参与秒杀。</p>
                <p>2.为了让更多用户享受到活动福利，该秒杀活动的所有活动商品或优惠券每位用户限抢一单。</p>
                <p>3.同一手机设备、手机号、微信账户、IP地址等信息的任意一项或数项相同或重叠的，均将被认定为同一用户。 同一用户仅支持一个账号登录进行该活动。如用户多拍，活动方有权取消订单且无需承担任何责任。 </p>
                <p>4.参与活动过程中，如果有⽤⼾出现违规⾏为（如作弊购买、恶意套现、虚假交易等)，识货有权取消违规⽤⼾的获取资格；</p>
                <p>5.活动中若涉及邮费可能需要参与者⾃理；此活动真实有效，特此说明。</p>
              </div>
              <img src="https://sh1.shihuocdn.cn/images/bargain/close.png" alt="" className="close" onClick={() => this.closePopup()} />
            </div>
            )
          }
        </div>
      );
    }
   
  }

  // 立即下载
  handleDownLoad = () => {
    const { from = "", customAttributes = {} } = this.props;
    const block = customAttributes["data-component-block"];
    window.sa && window.sa.track('pcClick', {
      env: 'toufang',
      version: '1.0.0',
      extra: from,
      sort: 0,
      action: `${block}`,
      page: window.location.href
    });

    utils.uploadTrack(this.props, {}, {
      blockName: 'winning-download'
    });

    const link = "https://www.shihuo.cn";
    utils.handleToufangClick({
      link,
      props: this.props,
    });
  }

  closePopup = () => {
    this.setState({
      mask_show: false,
      prize_show: false,
      success_show: false,
      rule_show: false
    })
  }

  createScript = () => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.type = "text/javascript";
    script.src = "https://www.shihuo.cn/js/lib/vFramePlayer.min.js";
    head.appendChild(script);
  }

}

export { PipelineLottery };
export default PipelineLottery;



// WEBPACK FOOTER //
// ./components/pipeline-lottery/index.js